export const echarts = {
  inserted: (el, binding) => {
    if (typeof binding.value === 'function') {
      binding.value(el)
    } else {
      console.error('the value of v-echarts expected a function')
    }
  }
}

// export const inputLimit ={
//   inputLimit: (el, binding) =>{                      // 定义dom节点和值
//     binding.value = binding.value || 0     // 如果有value  就使用value  如果没有  就用0
//     const wins_0 = /[^\d]/g                // 整数判断

//     const wins_1 = /[^\d^\.]/g             // 小数判断

//     let flag = true;

//     let points = 0;

//     let lengths = 0

//     let remainder = 0

//     let no_int = 0
//      //如果el是一个节点就返回节点 如果不是就注册input事件   el-input是一个组件不是节点
//     const target = el instanceof HTMLInputElement ? el : el.querySelector('input'); 

//     // 但是在 iOS 中，input 事件会截断非直接输入，什么是非直接输入呢，在我们输入汉字的时候，比如说「喜茶」，
//     // 中间过程中会输入拼音，每次输入一个字母都会触发 input 事件，然而在没有点选候选字或者点击「选定」按钮前，都属于非直接输入。
//     // 这显然不是我们想要的结果，我们希望在直接输入之后才触发 input 事件，
//  //  ================================================================================================
//     // 这就需要引出我要说的两个事件—— compositionstart 和compositionend。
//     // compositionstart 事件在用户开始进行非直接输入的时候触发，而在非直接输入结束，
//     // 也即用户点选候选词或者点击「选定」按钮之后，会触发 compositionend 事件。
//  //  ================================================================================================
//     // 添加一个 flag 变量，当用户未完成直接输入前，flag 为 true，
//     // 不触发 input 事件中的逻辑，当用户完成有效输入之后，inputLock 设置为 false，触发 input 事件的逻辑。
//     // 这里需要注意的一点是，compositionend 事件是在 input 事件后触发的，所以在 compositionend事件触发时，也要调用 input 事件处理逻辑。
    
//     target.addEventListener('compositionstart', e => {  //未输入完  还在候选词的时候触发  
//       flag = false;
//     });
//     target.addEventListener('compositionend', e => {    //输入完  结束候选词的时候触发
//       flag = true;
//     });
    
    
//     target.addEventListener('input', e => { // 给input监听事件
//       setTimeout(function() { 
//         if (flag) { //如果输入结束了  就触发
//           if (binding.value === 0) { // 如果值等于0
//             if (wins_0.test(e.target.value)) { 
//               e.target.value = e.target.value.replace(wins_0, '');
//               e.target.dispatchEvent(new Event('input')) // 手动更新v-model值
//             }
//           }
//           if (binding.value === 1) {
//             if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
//               remainder = true
//             }
//             if ((e.target.value.split('.')).length - 1 > 1) {
//               points = true
//             }
//             if (e.target.value.toString().split('.')[1] !== undefined) {
//               if (e.target.value.toString().split('.')[1].length > 1) {
//                 lengths = true
//               }
//             }
//             if (e.target.value.toString().indexOf('.') !== -1) {
//               no_int = false
//             } else {
//               no_int = true
//             }
//             if (wins_1.test(e.target.value) || lengths || points || remainder) {
//               if (!no_int) {
//                 e.target.value = e.target.value.replace(wins_1, '').replace('.', '$#$').replace(/\./g, '').replace(
//                   '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
//                   '.') + 2)
//               } else {
//                 e.target.value = e.target.value.replace(wins_0, '')
//               }
//               e.target.dispatchEvent(new Event('input'))
//             }
//           }

//           if (binding.value === 2) {
//             if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
//               remainder = true
//             }
//             if ((e.target.value.split('.')).length - 1 > 1) {
//               points = true
//             }
//             if (e.target.value.toString().split('.')[1] !== undefined) {
//               if (e.target.value.toString().split('.')[1].length > 2) {
//                 lengths = true
//               }
//             }
//             if (e.target.value.toString().indexOf('.') !== -1) {
//               no_int = false
//             } else {
//               no_int = true
//             }
//             if (wins_1.test(e.target.value) || lengths || points || remainder) {
//               if (!no_int) {
//                 e.target.value = e.target.value.replace(wins_1, '').replace('.', '$#$').replace(/\./g, '').replace(
//                   '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
//                   '.') + 3)
//               } else {
//                 e.target.value = e.target.value.replace(wins_0, '')
//               }
//               e.target.dispatchEvent(new Event('input'))
//             }
//           }
//         }
//         target.dispatchEvent(new Event('input')) // 这个是点睛之笔
//       }, 0)
//     })
//   }

// }






// WEBPACK FOOTER //
// ./src/directives/directives.js